import { IPlatformEvent } from 'modules/event-manager/event-manager.service';
import URLParams from 'utils/url-params';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

export const PLATFORM_URL_PARAMETER = 'platform';

export function getEarliestPlatform(platforms: IPlatformEvent[]): IPlatformEvent {
    let platformWithEarliestStartDate = platforms[0];

    for (let i = 1; i < platforms.length; i++) {
        const platform = platforms[i];
        if (platformWithEarliestStartDate.startDate > platform.startDate) {
            platformWithEarliestStartDate = platform;
        }
    }

    return platformWithEarliestStartDate;
}

export const getPlatformFromURL = (platforms: PLATFORM_TYPES[]): PLATFORM_TYPES | null => {
    const platformUrlValue = URLParams().get(PLATFORM_URL_PARAMETER);
    const platformFromURL: PLATFORM_TYPES | undefined = platforms.find(platform => platform === platformUrlValue);
    return platformFromURL ? platformFromURL : null;
};
